export default "__VITE_ASSET__c663a886__"